import axios from 'axios';
import store from '../store/store';

const api = axios.create ({
    baseURL: process.env.VUE_APP_AXIOS_BASE_URL,
});

api.interceptors.request.use(function(config) {
    const token = store.getters['user/tokenString'];
    if(token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});

export default api;